// extracted by css-extract-rspack-plugin
export default {"activeItem":"MetabotConversationHistory-module__activeItem___XAM6i"};